import React from "react";
import { formatNumber } from "utils/currencyFormat";
import ThemSuaThuocTinhGiamTru from "./ChucNang/ThemSuaThuocTinhGiamTru";
import XoaThuocTinhGiamTru from "./ChucNang/XoaThuocTInhGiamTru";
import ThuocTinhGiamTruApi from "service/ThuocTinhGiamTruApi";
import { pushNotification } from "utils/notifications";
import { useState } from "react";

const ThuocTinhGiamTruTable = ({ list, RoleThemMoiThuocTinhGiamTru, RoleSuaThuocTinhGiamTru, RoleXoaThuocTinhGiamTru, listCauHinhTaiSan, onSearch }) => {
    const [showModel, setShowModel] = useState(false);
    const [showModelXoa, setshowModelXoa] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [delId, setdelId] = useState(0);

    const btn_xoaThuocTinhGiamTruClick = (id) => {
        setdelId(id);
        setshowModelXoa(true);
    }
    const btn_SuaThuocTinhGiamTruClick = (item) => {
        setEditingItem(item);
        setShowModel(true);
    }
    const btn_themmoiThuocTinhGiamTruClick = () => {
        setEditingItem({
            ThuocTinhGiamTruId: 0,
            CauHinhTaiSanId: 0,
            TenThuocTinh: "",
            TienGiamTru: 0,
            KeyThuocTinhGiamTru: "",
            isDel: true
        })
        setShowModel(true);
    }

    const onSaveThemSuaThuocTinhGiamTru = async (data) => {
        let success = "";
        let error = "";
        try {
            const res = await ThuocTinhGiamTruApi.addoreditThuocTinhGiamTru(data);
            const dataResponse = res.data;
            if (res.status === 200) {
                if (data.ThuocTinhGiamTruId !== 0) {
                    success = "Sửa thành công.";
                    setShowModel(false);
                }
                else {
                    success = "Thêm mới thành công.";
                    setShowModel(false);
                }
                pushNotification(success, "success", "TOP_CENTER", 1000);
                await onSearch();
            }
            else {
                if (data.ThuocTinhGiamTruId !== 0) {
                    error = "Sửa thất bại: " + dataResponse.Messages;
                }
                else {
                    error = dataResponse.Messages;
                    console.log("Error: ", error);
                }
                pushNotification(error, "error", "TOP_CENTER", 1000);
            }
        }
        catch (err) {
            console.error("Lỗi:", err);
            if (data.ThuocTinhGiamTruId !== 0) {
                error = "Lỗi khi gọi Api Sửa!";
            }
            else {
                error = "Lỗi khi gọi Api Thêm mới!";
            }
            pushNotification(error, "error", "TOP_CENTER", 1000);
        }
    }

    const onDelete = async (id) => {
        try {
            await ThuocTinhGiamTruApi.deleteThuocTinhGiamTru({ id });
            pushNotification("Xóa thành công!", "success", "TOP_CENTER", 1000);
            setshowModelXoa(false);
            await onSearch();
        } catch (err) {
            console.error("Lỗi khi xóa:", err);
            pushNotification("Không thể xóa. Vui lòng thử lại!", "error", "TOP_CENTER", 1000);
        }
    }


    if (!list || list.length === 0) {
        return (<>
            <div className="Left808x200 Table-main-new css-table-ds">
                <div className="card-body card-body-v2" style={{ marginBottom: "10px", maxHeight: "54px", display: RoleThemMoiThuocTinhGiamTru ? "block" : "none", }}>
                    <div className="search-new" >
                        <div className="input-sm-new" style={{ width: "12%" }}>
                            <button className="btn btn-sm" onClick={btn_themmoiThuocTinhGiamTruClick} style={{ minWidth: "100%", color: "#00B69B", border: "2px solid #00B69B", backgroundColor: "white" }}><img src="/app-assets/images/icon-them-moi-cam-do.png" class="icon-button-v2" /><span style={{ color: "" }}>Thêm mới</span></button>
                        </div>
                    </div>
                </div>
                <div className="custom-table-row">
                    <div className="custom-table-cell-v2 text-center red" style={{ width: "100%" }}>
                        Không có dữ liệu
                    </div>
                </div>
            </div>
            {
                showModel && (<ThemSuaThuocTinhGiamTru
                    onClose={() => setShowModel(false)}
                    onSave={onSaveThemSuaThuocTinhGiamTru}
                    data={editingItem}
                    listCauHinhTaiSan={listCauHinhTaiSan}
                />)
            }
        </>
        );
    }
    return (<>
        <div className="Left808x200 Table-main-new css-table-ds">
            <div className="card-body card-body-v2" style={{ marginBottom: "10px", maxHeight: "54px", display: RoleThemMoiThuocTinhGiamTru ? "block" : "none", }}>
                <div className="search-new" >
                    <div className="input-sm-new" style={{ width: "12%" }}>
                        <button className="btn btn-sm" onClick={btn_themmoiThuocTinhGiamTruClick} style={{ minWidth: "100%", color: "#00B69B", border: "2px solid #00B69B", backgroundColor: "white" }}><img src="/app-assets/images/icon-them-moi-cam-do.png" class="icon-button-v2" /><span style={{ color: "" }}>Thêm mới</span></button>
                    </div>
                </div>
            </div>
            <div className="table-mobile sticky-table-bh2 table-mobile-hover">
                <div className="custom-table-wrapper" style={{ overflowX: "auto" }}>
                    <div className="table-headers" >
                        <div className="custom-table-header flex-basis-5 flex-basis-5-sm text-center">
                            <p className="color-do-bold">
                                STT
                                <br />[{list.length === 0 ? 0 : list.length}]
                            </p>
                        </div>
                        <div className="custom-table-header flex-basis-15 flex-basis-15-sm r">
                            <p>Loại tài sản</p>
                        </div>
                        <div className="custom-table-header flex-basis-15 flex-basis-15-sm " >
                            <p>Tên thuộc tính giảm trừ</p>
                        </div>
                        <div className="custom-table-header flex-basis-15 flex-basis-15-sm " >
                            <p>Tiền giảm trừ</p>
                        </div>
                        <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                            <p>Chức năng</p>
                        </div>
                    </div>
                    <div className="custom-table-body">
                        <ThuocTinhGiamTruTableRows
                            list={list}
                            RoleSuaThuocTinhGiamTru={RoleSuaThuocTinhGiamTru}
                            RoleXoaThuocTinhGiamTru={RoleXoaThuocTinhGiamTru}
                            btn_SuaThuocTinhGiamTruClick={btn_SuaThuocTinhGiamTruClick}
                            btn_xoaThuocTinhGiamTruClick={btn_xoaThuocTinhGiamTruClick}
                        />
                    </div>
                </div>
            </div>
        </div>
        {
            showModel && (<ThemSuaThuocTinhGiamTru
                onClose={() => setShowModel(false)}
                onSave={onSaveThemSuaThuocTinhGiamTru}
                data={editingItem}
                listCauHinhTaiSan={listCauHinhTaiSan}
            />)
        }
        {
            showModelXoa && (
                <XoaThuocTinhGiamTru
                    ThuocTinhGiamTruId = {delId}
                    onClose={() => setshowModelXoa(false)}
                    onDelete={onDelete}
                />
            )
        }
    </>
    )
};
const ThuocTinhGiamTruTableRows = ({ list, RoleSuaThuocTinhGiamTru, RoleXoaThuocTinhGiamTru, btn_SuaThuocTinhGiamTruClick, btn_xoaThuocTinhGiamTruClick }) => {
    return list.map((item, index) => {
        const isDel = item.isDel;
        return (
            <div className="custom-table-row" key={"item" + index} style={{ minHeight: "62px" }}>
                <div className="custom-table-cell-v2 flex-basis-5 flex-basis-5-sm disk-mobile " >
                    <span className="mobile-column-name color7-bold">STT</span>
                    <div className="center-wrapper" >
                        <p className="text-center color7">{index + 1}</p>
                    </div>
                </div>
                <div className="custom-table-cell-v2 flex-basis-15 flex-basis-15-sm " >
                    <span className="mobile-column-name color7-bold">Loại tài sản</span>
                    <div className="center-wrapper color7"
                        title={item.TenHangSanXuat}>
                        {item.TenHangHoa}
                    </div>
                </div>
                <div className="custom-table-cell-v2  flex-basis-15 flex-basis-15-sm ">
                    <span className="mobile-column-name color7-bold">Tên thuộc tính giảm trừ</span>
                    <div className="center-wrapper color7"
                        title={item.TenThuocTinh}
                    >
                        {item.TenThuocTinh}
                    </div>
                </div>
                <div className="custom-table-cell-v2  flex-basis-15 flex-basis-15-sm ">
                    <span className="mobile-column-name color7-bold">Tiền giảm trừ</span>
                    <div className="center-wrapper color7"
                    >
                        {formatNumber(item.TienGiamTru)}
                    </div>
                </div>
                <div className="custom-table-cell-v2 flex-basis-10 flex-basis-10-sm" >
                    <span className="mobile-column-name color7-bold">Chức năng</span>
                    <div className="center-wrapper" >
                        {RoleSuaThuocTinhGiamTru && (
                            <>
                                <div className="iconTableMorman">
                                    <a
                                        title="Sửa"
                                        onClick={() => btn_SuaThuocTinhGiamTruClick(item)}
                                    >
                                        <img src="/app-assets/images/icon-edit-v2.png" />
                                    </a>
                                </div>
                            </>
                        )}
                        {RoleXoaThuocTinhGiamTru && item.isDel && (
                            <>
                                <div className="iconTableMorman">
                                    <a title="Xóa"
                                        onClick={() => btn_xoaThuocTinhGiamTruClick(item.ThuocTinhGiamTruId)}
                                    >
                                        <img src="/app-assets/images/icon-xoa-v2.png" />
                                    </a>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        )
    });
};

export default ThuocTinhGiamTruTable;